import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import LeftArrowIcon from 'components/LeftArrowIcon'

const BannerBackButton = ({ to, text }) => (
  <Link
    to={to}
    className="text-sm absolute flex items-center text-white left-5 pt-2 top-16 hover:text-white hover:opacity-80 md:text-base md:left-10 md:pt-4"
  >
    <div className="bg-white rounded-full bg-opacity-10 h-8 w-8 flex justify-center items-center mr-2">
      <LeftArrowIcon className="w-3 h-3" />
    </div>
    <span>{text}</span>
  </Link>
)

BannerBackButton.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string,
}

export default BannerBackButton
